import supabase from '../../supabase/supabase';

export const getParents = async (householdId) => {
  const { data, error } = await supabase
    .from('members_20240320')
    .select('*')
    .eq('household_id', householdId);

  if (error) throw error;
  return data.map(m => ({
    id: m.user_id,
    email: m.email || 'Unknown User',
    role: m.role
  }));
};

export const removeParent = async (householdId, adminId, targetUserId) => {
  const { error } = await supabase
    .from('members_20240320')
    .delete()
    .eq('household_id', householdId)
    .eq('user_id', targetUserId);
  if (error) throw error;
};

export const createInvite = async (householdId, adminId) => {
  const token = crypto.randomUUID();
  const expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
  
  const { error } = await supabase
    .from('invites_20240320')
    .insert({
      household_id: householdId,
      invited_by: adminId,
      token,
      expires_at: expiresAt
    });

  if (error) throw error;
  return token;
};

export const getInvite = async (token) => {
  const { data: invite, error } = await supabase
    .from('invites_20240320')
    .select('*')
    .eq('token', token)
    .single();

  if (error || !invite) throw new Error("Invalid invite link.");
  if (invite.is_used) throw new Error("This invite link has already been used.");
  if (new Date() > new Date(invite.expires_at)) throw new Error("This invite link has expired.");

  return invite;
};